import { useState } from '#app/composables/state';

/**
 * Changing layout during navigation
 */
export const useChangingLayout = () => useState('changingLayout', () => false);
